import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgTickCheckIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 42,
	height: 42,
	viewBox: "0 0 42 42",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("rect", {
		width: 42,
		height: 42,
		rx: 21,
		fill: "#4A9167"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M33.1152 13.9414L17.4541 30.1426L8.88477 19.8584L11.1895 17.9385L17.6191 25.6543L30.959 11.8555L33.1152 13.9414Z",
		fill: "white"
	})]
});
export default SvgTickCheckIcon;
